import React, { useEffect, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { api } from "./api";
export const TYPES = [
  "ENTREGA_REGULAR",
  "ENTREGA_ADICIONAL",
  "REPOSICION",
  "EMERGENCIA",
  "DEVOLUCION",
  "AJUSTE",
  "DESINCORPORACION",
];
export const DESTINATION_TYPES = [
  "RUTA",
  "CONSUMO_INTERNO",
  "DEGUSTACION",
  "EVENTO",
  "PRUEBA_TECNICA",
  "PERSONAL_AUTORIZADO",
];
export const label = (value) => (value || "").replace(/_/g, " ");
export const date = (value) =>
  value
    ? new Date(value).toLocaleDateString("en-CA", {
        timeZone: "America/Panama",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
    : "";
export const today = () => date(new Date());
export const target = (m) =>
  (m.customer?.locationId ? m.customer.name : m.destination?.name || m.customer?.name) || "Sin destino";
export const dispatchName = (m) => m.state === "SOLICITADO" ? "—" : m.dispatchedBy?.name || "—";
export function Field({ title, children }) {
  return (
    <label className="sd-field">
      <span>{title}</span>
      {children}
    </label>
  );
}
export function Select({
  title,
  value,
  onChange,
  options,
  disabled,
  required = false,
  empty = "Seleccionar…",
}) {
  return (
    <Field title={title}>
      <select
        aria-label={title}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required={required}
      >
        <option value="">{empty}</option>
        {options.map((o) => (
          <option key={o.value ?? o} value={o.value ?? o}>
            {o.label ?? label(o)}
          </option>
        ))}
      </select>
    </Field>
  );
}
export function Lookup({
  title,
  path,
  value,
  onChange,
  active = true,
  query = {},
  disabled = false,
  inputRef,
}) {
  const [suggestions, setSuggestions] = useState([]),
    [error, setError] = useState("");
  const serial = React.useRef(0);
  useEffect(
    () => () => {
      serial.current++;
    },
    []
  );
  const decorate = (r) => ({
    ...r,
    lookupLabel: r.code
      ? `${r.code} · ${r.name} · ${r.presentation || ""}`
      : `${r.name || r.displayName}${r.email ? " · " + r.email : ""}${
          r.businessUnit ? " · " + r.businessUnit : ""
        }${r.isOperator ? " (Operador)" : ""}`,
  });
  return (
    <Field title={title}>
      <AutoComplete
        aria-label={title}
        disabled={disabled}
        inputRef={inputRef}
        value={
          typeof value === "object" && value ? decorate(value) : value || ""
        }
        suggestions={suggestions}
        field="lookupLabel"
        dropdown
        delay={150}
        minLength={0}
        completeMethod={async (e) => {
          const current = ++serial.current;
          try {
            const data = await api(path, "GET", undefined, {
              ...query,
              q: e.query,
              limit: 200,
              ...(path === "insumos" || path === "destinos"
                ? { active: active ? true : undefined }
                : {}),
            });
            if (current === serial.current) {
              setSuggestions(data.rows.map(decorate));
              setError("");
            }
          } catch (err) {
            if (current === serial.current) setError(err.message);
          }
        }}
        onChange={(e) => onChange(e.value)}
      />
      {error && <small role="alert">{error}</small>}
    </Field>
  );
}
export function Pager({ data, page, setPage }) {
  return (
    <div className="sd-toolbar">
      <Button
        label="Anterior"
        disabled={page <= 1}
        onClick={() => setPage(page - 1)}
      />
      <span>
        Página {page} · {data.total || 0} registros
      </span>
      <Button
        label="Siguiente"
        disabled={page * (data.limit || 50) >= data.total}
        onClick={() => setPage(page + 1)}
      />
    </div>
  );
}
export function useData(path, query = {}, refresh = 0) {
  const [state, setState] = useState({ data: null, loading: true, error: "" });
  const key = JSON.stringify(query);
  useEffect(() => {
    let current = true;
    setState({ data: null, loading: true, error: "" });
    api(path, "GET", undefined, JSON.parse(key))
      .then((data) => {
        if (current) setState({ data, loading: false, error: "" });
      })
      .catch((error) => {
        if (current)
          setState({ data: null, loading: false, error: error.message });
      });
    return () => {
      current = false;
    };
  }, [path, key, refresh]);
  return state;
}
export function Status({ loading, error }) {
  return (
    <>
      {loading && <p role="status">Cargando…</p>}
      {error && (
        <p role="alert" className="sd-error">
          {error}
        </p>
      )}
    </>
  );
}

